<template>
  <div class="nav_link__wrapper">
    <router-link
      v-if="item.visible"
      class="nav_link"
      :class="{ 'has-icon': item.icon, disabled: !item.is_enabled }"
      :to="{ name: item.path_name }"
    >
      <div v-if="item.icon" class="nav_icon">
        <img class="nav_icon_img nav_icon_img__normal" :src="`/static/images/vacancy/navigation/${item.icon}`" />
        <img class="nav_icon_img nav_icon_img__hover" :src="`/static/images/vacancy/navigation/hover_${item.icon}`" />
      </div>

      <span>{{ item.name }}</span>
    </router-link>

    <vcv-billing-lock
      v-if="item.feature !== undefined && isFeatureDisabledByTariff(item.feature)"
      :feature="item.feature"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VcvBillingLock from '@/routes_new/inner/billing/VcvBillingLock';

export default {
  name: 'VacancyNavigationItem',

  components: {
    VcvBillingLock
  },

  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters('company_new', ['isFeatureDisabledByTariff'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.nav_icon {
  position: relative;
  margin-right: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100%;
    max-height: 100%;
  }

  .nav_icon_img__normal {
    opacity: 1;
  }

  .nav_icon_img__hover {
    opacity: 0;
  }

  &:hover {
    .nav_icon_img__normal {
      opacity: 0;
    }
    .nav_icon_img__hover {
      opacity: 1;
    }
  }
}

.nav_link__wrapper {
  display: flex;
  justify-content: space-between;
}

a.nav_link {
  position: relative;
  display: flex;
  align-items: center;
  line-height: 24px;
  font-size: 15px;
  color: $main-dark;
  padding: 8px 35px;
  width: 100%;
  transition: all ease-in-out 0.3s;

  .nav_icon_img {
    color: $main-dark;
    transition: all ease-in-out 0.3s;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    transition: all ease-in-out 0.3s;
    background: transparent;
  }

  &:hover,
  &.router-link-active {
    color: $green;
    background: transparent;

    &:before {
      background: $green;
    }

    .nav_icon_img__normal {
      opacity: 0;
    }

    .nav_icon_img__hover {
      opacity: 1;
    }
  }

  &:hover {
    background: $background;
  }

  span {
    text-transform: capitalize;
    padding-left: 2rem;
  }

  &.has-icon {
    span {
      padding-left: 0;
    }
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.nav_link_text {
  display: block;
  margin-right: 14px;
}

.nav_link__disabled {
  color: #9faab6;

  &:hover {
    color: #9faab6;
  }
}
</style>
